import actions from "./actions";

const initialState = {
  rows: [],
  total: 0,
  taskTotal: 0,
  summaryRowCount: 0,
  plannedHours: [],
  holdHours: [],
  doTimesheetHoursByDay: {},
  checkTimesheetHoursByDay: {},
  doRemainingHoursByDay: {},
  checkRemainingHoursByDay: {},
  requesting: false,
  appendingWeek: false,
  saving: false,
  error: null,
};

const mergePlannedHours = (existing, incoming) => {
  const byDate = new Map();
  (existing || []).forEach((item) => {
    if (item?.workDate != null) {
      byDate.set(String(item.workDate), item);
    }
  });
  (incoming || []).forEach((item) => {
    if (item?.workDate != null) {
      byDate.set(String(item.workDate), item);
    }
  });
  return Array.from(byDate.values());
};

const mergeHoldHours = (existing, incoming) => {
  const key = (item) =>
    `${item?.teamId}|${item?.hourSide}|${String(item?.workDate)}`;
  const byKey = new Map();
  (existing || []).forEach((item) => {
    byKey.set(key(item), item);
  });
  (incoming || []).forEach((item) => {
    byKey.set(key(item), item);
  });
  return Array.from(byKey.values());
};

export default function resourceSheetReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_LIST_RESOURCE_SHEET:
      return {
        ...state,
        requesting: true,
        error: null,
      };
    case actions.GET_LIST_RESOURCE_SHEET_SUCCESS:
      return {
        ...state,
        rows: action.rows,
        total: action.total,
        taskTotal: action.taskTotal || 0,
        summaryRowCount: action.summaryRowCount || 0,
        plannedHours: action.plannedHours || [],
        holdHours: action.holdHours || [],
        doTimesheetHoursByDay: action.doTimesheetHoursByDay || {},
        checkTimesheetHoursByDay: action.checkTimesheetHoursByDay || {},
        doRemainingHoursByDay: action.doRemainingHoursByDay || {},
        checkRemainingHoursByDay: action.checkRemainingHoursByDay || {},
        requesting: false,
        error: null,
      };
    case actions.GET_LIST_RESOURCE_SHEET_ERROR:
      return {
        ...state,
        requesting: false,
        error: action.error,
      };
    case actions.SAVE_RESOURCE_SHEET:
      return {
        ...state,
        saving: true,
        error: null,
      };
    case actions.SAVE_RESOURCE_SHEET_SUCCESS:
      return {
        ...state,
        saving: false,
        error: null,
      };
    case actions.SAVE_RESOURCE_SHEET_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error,
      };
    case actions.APPEND_RESOURCE_SHEET_WEEK:
      return {
        ...state,
        appendingWeek: true,
        error: null,
      };
    case actions.APPEND_RESOURCE_SHEET_WEEK_SUCCESS:
      return {
        ...state,
        plannedHours: mergePlannedHours(state.plannedHours, action.plannedHours),
        holdHours: mergeHoldHours(state.holdHours, action.holdHours),
        appendingWeek: false,
        error: null,
      };
    case actions.APPEND_RESOURCE_SHEET_WEEK_ERROR:
      return {
        ...state,
        appendingWeek: false,
        error: action.error,
      };
    default:
      return state;
  }
}
